define ['./warning.scss'], () ->
  () ->
    restrict: "E"
    template: require("./warning.jade")
    scope: {warning: "=",  callbackclear: "&", onlyonce: "=", confirmtext: "@", discardtext: "@"}
    link: (scope, element, attrs) ->
      scope.displayMessage = true

      scope.close = ($event, result) ->
        $event.stopPropagation()
        if scope.callbackclear && result == 'discard'
          scope.callbackclear()
        if scope.onlyonce
          scope.displayMessage = false
        scope.warning.visible = false



// WEBPACK FOOTER //
// ./directives/freeforms/warning/warning.coffee